import styled, { css } from "styled-components";
import { Button } from "rebass";

export const FontSizeButton = styled(Button).attrs({ type: "button" })`
  text-transform: uppercase;
  transition: all 0.4s;
  
  &:disabled {
    ${({ theme: { colors } }) => css`
      color: ${colors["hoki"]};
      background-color: ${colors["hoki-25"]};
    `};
  }
`;

FontSizeButton.defaultProps = {
  width: [0.5],
  borderColor: "#ededed",
  borderRadius: 0,
  color: "#202020",
  bg: "transparent",
};
